import { render, staticRenderFns } from "./OrganisationSelfRegistrationEdit.vue?vue&type=template&id=693f910e&"
import script from "./OrganisationSelfRegistrationEdit.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSelfRegistrationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693f910e')) {
      api.createRecord('693f910e', component.options)
    } else {
      api.reload('693f910e', component.options)
    }
    module.hot.accept("./OrganisationSelfRegistrationEdit.vue?vue&type=template&id=693f910e&", function () {
      api.rerender('693f910e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationSelfRegistrationEdit.vue"
export default component.exports